// extracted by mini-css-extract-plugin
export default {"footer":"index_footer_VfTiZ","foot_link":"index_foot_link_Ke1mr","list":"index_list_Rl-yj","link":"index_link_5fIwD","copyright":"index_copyright_kgeDi"};